module.exports = __webpack_public_path__ + "img/employer-testimonial-01.1781e786.jpg";